import Select from '../../../../components/form/Select';
import { Component } from 'preact';
import DatePicker from 'react-datepicker';
import { connect } from 'unistore/preact';
import { format } from 'date-fns';
import { Text, Localizer } from 'preact-i18n';
import get from 'get-value';

import 'react-datepicker/dist/react-datepicker.css';
import datePickerStyle from '../../../../components/datePicker.module.css';
import style from './CheckTime.module.css';

import { fr, de, es } from 'date-fns/locale';

const weekDays = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];

const LOCALES = { fr, de, es };

class CheckTime extends Component {
  handleBeforeTimeChange = time => {
    const timeFormatted = time ? format(time, 'HH:mm') : undefined;
    this.props.updateActionProperty(this.props.path, 'before', timeFormatted);
  };
  handleBeforeAfterChange = time => {
    const timeFormatted = time ? format(time, 'HH:mm') : undefined;
    this.props.updateActionProperty(this.props.path, 'after', timeFormatted);
  };
  handleDayOfTheWeekChange = options => {
    const values = options ? options.map(option => option.value) : undefined;
    this.props.updateActionProperty(this.props.path, 'days_of_the_week', values);
  };

  render() {
    const language = get(this.props, 'user.language');
    const { path } = this.props;
    const localeSet = LOCALES[language] || 'en';
    const before = this.props.action.before
      ? new Date().setHours(this.props.action.before.substr(0, 2), this.props.action.before.substr(3, 2))
      : null;
    const after = this.props.action.after
      ? new Date().setHours(this.props.action.after.substr(0, 2), this.props.action.after.substr(3, 2))
      : null;
    const daysOfTheWeekOptions = weekDays.map(weekDay => ({
      value: weekDay,
      label: <Text id={`editScene.triggersCard.scheduledTrigger.daysOfTheWeek.${weekDay}`} />
    }));
    const selectedWeekDaysOptions = this.props.action.days_of_the_week
      ? this.props.action.days_of_the_week.map(day => daysOfTheWeekOptions.find(option => option.value === day))
      : [];
    return (
      <div>
        {path && !path.includes('.if') && (
          <p>
            <small>
              <Text id="editScene.actionsCard.checkTime.description" />
            </small>
          </p>
        )}
        <div class="row">
          <div class="col">
            <div class="form-group">
              <div class="form-label">
                <Text id="editScene.actionsCard.checkTime.afterLabel" />
              </div>
              <Localizer>
                <DatePicker
                  selected={after}
                  className="form-control"
                  popperClassName={datePickerStyle.datePickerPopper}
                  portalId="scene-editor-datepicker"
                  clearButtonClassName={style.clearButtonCustom}
                  locale={localeSet}
                  onChange={this.handleBeforeAfterChange}
                  placeholderText={<Text id="editScene.actionsCard.checkTime.afterLabel" />}
                  showTimeSelect
                  showTimeSelectOnly
                  isClearable
                  timeIntervals={5}
                  timeCaption={<Text id="editScene.actionsCard.checkTime.afterLabel" />}
                  dateFormat="HH:mm"
                />
              </Localizer>
            </div>
          </div>
          <div class="col">
            <div class="form-group">
              <div class="form-label">
                <Text id="editScene.actionsCard.checkTime.beforeLabel" />
              </div>
              <Localizer>
                <DatePicker
                  selected={before}
                  className="form-control"
                  popperClassName={datePickerStyle.datePickerPopper}
                  portalId="scene-editor-datepicker"
                  clearButtonClassName={style.clearButtonCustom}
                  locale={localeSet}
                  onChange={this.handleBeforeTimeChange}
                  placeholderText={<Text id="editScene.actionsCard.checkTime.beforeLabel" />}
                  showTimeSelect
                  showTimeSelectOnly
                  isClearable
                  timeIntervals={5}
                  timeCaption={<Text id="editScene.actionsCard.checkTime.beforeLabel" />}
                  dateFormat="HH:mm"
                />
              </Localizer>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="form-label">
            <Text id="editScene.actionsCard.checkTime.daysOfTheWeekLabel" />
          </div>
          <Select
            defaultValue={[]}
            isMulti
            value={selectedWeekDaysOptions}
            onChange={this.handleDayOfTheWeekChange}
            options={daysOfTheWeekOptions}
            className="react-select-container"
            classNamePrefix="react-select"
          />
        </div>
      </div>
    );
  }
}

export default connect('user', {})(CheckTime);
